<template>
	<div style="height: 100%;">
		<div v-show="!emptyState" ref="charts" style="height: 100%;"></div>
		<c-empty v-show="emptyState"></c-empty>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'
	import * as echarts from 'echarts'

	export default {
		data() {
			return {
				...getStore(this, 'digitalStore'),
				emptyState: false
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
		},

		methods: {
			update(data) {
				this.emptyState = !data.list.length;
				this.echartsObj.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						show: true,
						top: this.px(0),
						right: this.px(-4),
						icon: 'rect',
						itemWidth: this.px(14),
						itemHeight: this.px(6),
						textStyle: {
							fontSize: this.px(12),
							color: '#fff'
						}
					},
					grid: {
						top: this.px(40),
						bottom: this.px(30),
						left: this.px(16 + (Math.max.apply(window, data.list.map(item => item.left_value.toString().length)) + 2) * 8),
						right: this.px(16 + (Math.max.apply(window, data.list.map(item => item.right_value.toString().length)) + 2) * 8)
					},
					xAxis: {
						type: 'category',
						axisLine: {
							lineStyle: {
								color: '#4E8AB1'
							}
						},
						axisLabel: {
							fontSize: this.px(12),
							color: '#31C6FD'
						},
						data: data.list.map(item => item.name)
					},
					yAxis: [{
						type: 'value',
						axisLine: {
							show: false
						},
						axisLabel: {
							fontSize: this.px(13),
							color: '#fff'
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255,255,255,.05)'
							}
						}
					}, {
						type: 'value',
						axisLine: {
							show: false
						},
						axisLabel: {
							fontSize: this.px(13),
							color: '#fff'
						},
						splitLine: {
							show: false
						}
					}],
					series: [{
						name: data.left_name,
						type: 'bar',
						barWidth: this.px(30),
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#0A71F8' },
								{ offset: 1, color: '#07BFED' }
							])
						},
						data: data.list.map(item => item.left_value)
					}, {
						name: data.right_name,
						type: 'line',
						smooth: true,
						yAxisIndex: 1,
						color: '#07F3A4',
						data: data.list.map(item => item.right_value)
					}]
				});
			}
		}
	}
</script>

